var _style, _path, _path2, _path3, _path4, _circle, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 462 149.5",
    style: {
      enableBackground: "new 0 0 462 149.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D8E2FF;}\n\t.st1{fill:#04A8F0;}\n\t.st2{fill:#686DF1;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.8,57.9v60.7c-0.5,0.2-1.4,0.4-2.4,0.6c-1,0.2-2.1,0.4-3.3,0.4c-2.4,0-4.1-0.4-5.1-1.3 c-1-0.9-1.5-2.5-1.5-4.6V57.9h-20.6c-0.4-0.5-0.7-1.3-1-2.1c-0.2-0.9-0.3-1.8-0.3-2.9c0-1.7,0.4-3,1.2-3.9c0.9-0.9,2-1.4,3.4-1.4 h50.6c0.3,0.5,0.6,1.1,0.8,2c0.3,0.9,0.5,1.8,0.5,2.8c0,3.7-1.5,5.5-4.5,5.5H242.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.2,119c-2,0-3.6-0.6-4.9-1.9c-1.2-1.3-1.9-2.9-1.9-4.9V54.2c0-2,0.6-3.6,1.9-4.8c1.2-1.3,2.9-1.9,4.9-1.9 h38.5c0.4,0.5,0.7,1.1,0.9,2c0.3,0.9,0.5,1.8,0.5,2.8c0,1.7-0.4,3.1-1.3,4c-0.8,0.9-1.9,1.4-3.3,1.4h-29.8v19.5h29.4 c0.4,0.5,0.7,1.1,0.9,2c0.3,0.9,0.5,1.8,0.5,2.8c0,1.8-0.4,3.1-1.3,4c-0.8,0.9-1.9,1.3-3.3,1.3h-26.3v21.4h33.5 c0.3,0.5,0.6,1.1,0.9,2c0.3,0.9,0.5,1.8,0.5,2.8c0,1.8-0.4,3.2-1.3,4.1c-0.8,0.9-1.9,1.3-3.3,1.3H285.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.4,57.9v60.7c-0.5,0.2-1.4,0.4-2.4,0.6c-1,0.2-2.1,0.4-3.3,0.4c-2.4,0-4.1-0.4-5.1-1.3 c-1-0.9-1.5-2.5-1.5-4.6V57.9h-20.6c-0.4-0.5-0.7-1.3-1-2.1c-0.2-0.9-0.3-1.8-0.3-2.9c0-1.7,0.4-3,1.2-3.9c0.9-0.9,2-1.4,3.4-1.4 h50.6c0.3,0.5,0.6,1.1,0.8,2c0.3,0.9,0.5,1.8,0.5,2.8c0,3.7-1.5,5.5-4.5,5.5H369.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M462,93.8c0,4-0.7,7.6-2,10.9c-1.2,3.3-3.1,6.1-5.6,8.5c-2.4,2.3-5.4,4.2-9,5.4c-3.5,1.3-7.5,1.9-12.1,1.9 c-4.5,0-8.5-0.6-12.1-1.9c-3.5-1.3-6.5-3.1-9-5.4c-2.4-2.4-4.3-5.2-5.6-8.5c-1.2-3.3-1.9-6.9-1.9-10.9V47.5c0.5-0.2,1.4-0.3,2.4-0.5 c1.1-0.2,2.2-0.4,3.4-0.4c2.2,0,3.9,0.4,5,1.3c1.1,0.9,1.6,2.4,1.6,4.6v40.5c0,5.6,1.5,9.8,4.5,12.7c3.1,2.9,6.9,4.3,11.5,4.3 c2.3,0,4.5-0.4,6.4-1.1c1.9-0.8,3.6-1.9,5.1-3.3s2.6-3.2,3.4-5.3c0.9-2.1,1.3-4.6,1.3-7.4V47.5c0.5-0.2,1.4-0.3,2.4-0.5 c1.1-0.2,2.2-0.4,3.4-0.4c2.2,0,3.9,0.4,5,1.3c1.1,0.9,1.6,2.4,1.6,4.6V93.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 78,
    cy: 26,
    r: 26
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78,67c-26.5,0-48-21.5-48-48C31.1,6,20,6,17,9.5c-0.2,0.2-0.4,0.4-0.7,0.7C6.1,23.5,0,40,0,58.1 c0,15.8,15,26,30.9,26h94.3c15.8,0,30.9-10.1,30.9-26c0-18-6.1-34.6-16.3-47.8c-0.2-0.3-0.4-0.5-0.7-0.7C136,6,124.9,6,126,19 C126,45.5,104.5,67,78,67z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.2,145.2l21.9-31.5c4.6-6.6-0.1-15.7-8.2-15.7H78H56.1c-8.1,0-12.8,9.1-8.2,15.7l21.9,31.5 C73.8,150.9,82.2,150.9,86.2,145.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f17b96a8861e01b9043e179ba8f504ea.svg";
export { ForwardRef as ReactComponent };